import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchHeatData,
  fetchHeatDetails,
} from "features/deviceConfig/deviceConfigThunk";
import {
  setDeviceData,
  setIntervalId,
} from "features/deviceConfig/deviceConfigSlice";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";

function FilterSection() {
  const [searchTerm, setSearchTerm] = React.useState("");
  const dispatch = useDispatch();
  const intervalId = useSelector((state) => state.deviceConfig.intervalId);
  const deviceData = useSelector((state) => state.deviceConfig.deviceData); 

    useEffect(() => {
    if (!deviceData) {
      setSearchTerm("");
    }
  }, [deviceData]);

  const handleSearchKeyPress = () => {
    // Agar pehle se koi polling chal rahi hai to usse pehle band karo
    if (intervalId) {
      clearInterval(intervalId);
      dispatch(setIntervalId(null));
    }

    dispatch(fetchHeatData(searchTerm));
    dispatch(fetchHeatDetails(searchTerm));

    const newIntervalId = setInterval(() => {
      if (searchTerm.trim() !== "") {
        dispatch(fetchHeatData(searchTerm));
        dispatch(fetchHeatDetails(searchTerm));
      }
    }, 4000);

    dispatch(setIntervalId(newIntervalId));
    dispatch(setDeviceData(true));
  };

  return (
    <MDBox display="flex" alignItems="center">
      <MDInput
        label="Search"
        variant="outlined"
        fullWidth
        borderRadius="0px !important"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        right="1rem"
        p={1.2}
        pb={1.3}
        sx={{ cursor: "pointer", background: "#2e83e6ff" }}
        borderRadius="0px 8px 8px 0px"
        onClick={handleSearchKeyPress}
      >
        <Icon fontSize="medium" sx={{ color: "#fff" }}>
          search
        </Icon>
      </MDBox>
    </MDBox>
  );
}

export default FilterSection;